import Model from '@ember-data/model';
import agreeable from 'garaje/utils/decorators/agreeable';

export type AgreementsStatus = 'not_applicable' | 'not_signed' | 'pending' | 'signed' | 'skipped';

@agreeable
class Agreeable extends Model {}

export default Agreeable;
